



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { HeadingItem, extractHeadings } from '@/lib/markdownUtils';

@Component({
  name: 'ArticleTableOfContents'
})
export default class ArticleTableOfContents extends Vue {
  @Prop({ required: true })
  public content!: string;

  public get headings(): HeadingItem[] {
    return extractHeadings(this.content);
  }

  public scrollToHeading(id: string): void {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
